import { FetchAPI } from '../Main/fetchAPI';
import { CLIENT } from '../constants';

export const PromptCode = {
	getPrompCodes: () =>
		FetchAPI.getJson({
			urlStr: `${CLIENT}/prompt-codes`,
		}),
};
